import React from 'react';

import { Box, Stack, createStyles, useMantineTheme } from '@mantine/core';
import { getMarkdownStyles } from 'components/ExtractedContent/markdownStyles';
import { Virtuoso } from 'react-virtuoso';

interface TextContentProps {
  rawText: string;
  lines: string[];
  lineCount: number;
}

const useStyles = createStyles((theme) => ({
  markdownContainer: {
    flex: 1,
    width: '100%',
    padding: '16px 0'
  },
  lineContent: {
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    padding: '2px 16px'
  },
  virtuosoContainer: {
    flex: 1,
    scrollbarColor: `${theme.colors.gray[4]} transparent`
  }
}));

export function TextContent({ rawText, lines, lineCount }: TextContentProps) {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  // Create line renderer for Virtuoso
  const renderLine = (index: number) => {
    return (
      <Box key={index} className={classes.lineContent}>
        {lines[index]}
      </Box>
    );
  };

  return (
    <Stack className={classes.markdownContainer} styles={getMarkdownStyles(theme)}>
      {lines.length > 0 ? (
        <Box className={classes.virtuosoContainer}>
          <Virtuoso totalCount={lineCount} itemContent={renderLine} useWindowScroll={false} />
        </Box>
      ) : (
        <pre>{rawText}</pre>
      )}
    </Stack>
  );
}
